import styled from 'styled-components';
import { NEUTRAL_700 } from 'visitor-ui-component-library/constants/WidgetColors';
export const Section = styled.div.withConfig({
  displayName: "Section",
  componentId: "sc-14gvxr8-0"
})(["padding:8px;"]);
export const SectionHeader = styled.div.withConfig({
  displayName: "Section__SectionHeader",
  componentId: "sc-14gvxr8-1"
})(["font-size:14px;font-weight:600;line-height:18px;color:", ";padding:8px;"], NEUTRAL_700);